export const GouvAddressSearchQueryKeys = {
  all: ["gouv", "address"] as const,
  autocomplete: (...args: unknown[]) => [...GouvAddressSearchQueryKeys.all, "autocomplete", ...args] as const,
};
